export const resultadoEsperadoContent = {
  titlePart1: "RESULTADO",
  titlePart2: "ESPERADO",
  bodyLead: "O Pastejo reposiciona a conversa da operação pecuária:",
  bodyRest:
    "deixa de ser apenas um sistema e passa a ser uma ferramenta de captura de valor dentro da fazenda. Quando executado corretamente, fortalece a governança operacional, amplia a capacidade de gestão e transforma a base de dados em um ativo estratégico para a evolução do negócio.",
  benefits: [
    "Recuperação de margem na execução operacional",
    "Governança mais sólida sobre a rotina da fazenda",
    "Dados com valor estratégico para a gestão",
    "Mais precisão, previsibilidade e escala",
    "Evolução contínua da performance operacional",
  ],
} as const;
